module.exports = __webpack_public_path__ + "img/4.ce0a0427.png";